import React from 'react'
import QdContainer from 'components/Common/QdContainer'
import { Provider } from './TmsLocationCreationContext'
import JobList from './JobList'

function TmsLocationCreation() {
    return (
        <Provider>
            <QdContainer>
                <JobList />
            </QdContainer>
        </Provider>
    )
}

export default TmsLocationCreation
